let scrollPos = 0;
let scrollPosStickyXL = 50;
let scrollPosStickyLG = 20;
let scrollPosHidden = 200;
const body = document.querySelector('body');

function checkPosition() {
    let windowY = window.scrollY;

    if (windowY < scrollPosStickyXL) {
        body.classList.remove('is-sticky-xl');
    } else {
        body.classList.add('is-sticky-xl');
    }

    if (windowY < scrollPosStickyLG) {
        body.classList.remove('is-sticky-lg');
    } else {
        body.classList.add('is-sticky-lg');
    }

    if (windowY < scrollPosHidden) {
        body.classList.remove('is-hidden');
    } else {
        body.classList.add('is-hidden');
    }

    scrollPos = windowY;
}

var Sticky = require('sticky-js');
var sticky = new Sticky('.c-productmenu');

checkPosition();
window.addEventListener('scroll', checkPosition);
window.addEventListener('scroll', sticky);
